import SpriteSymbol from "../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "user",
  "use": "user-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"user\"><g fill=\"none\" fill-rule=\"evenodd\"><path /><path fill=\"var(--bolt-theme-icon, currentColor)\" d=\"M19 17.6a8.3 8.3 0 00-4.3-3.4 4.9 4.9 0 10-5.5 0A8.3 8.3 0 005 17.6 9 9 0 1121 12a9 9 0 01-2 5.6m-9.9-7.4a2.9 2.9 0 115.8 0 2.9 2.9 0 01-5.8 0M12 21a9 9 0 01-5.6-2 6.3 6.3 0 0111.2 0 9 9 0 01-5.6 2m0-20a11 11 0 000 22 10.9 10.9 0 008-3.4A11 11 0 0012 1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol